const STAGING = 'demuxed-staging';
const PRODUCTION = 'demuxed-5ca37';
const PROJECTS = {
  [STAGING]: {
    apiKey: "AIzaSyB8-_Udz9f4mMo_b7bUl4G3lBw2_hmTErc",
    authDomain: "demuxed-staging.firebaseapp.com",
    databaseURL: "https://demuxed-staging.firebaseio.com",
    projectId: "demuxed-staging",
    storageBucket: "demuxed-staging.appspot.com",
    messagingSenderId: "1005049269293"
  },
  [PRODUCTION]: {
    apiKey: "AIzaSyDrSQ8maT_KUooQfJhYSyDPWHLDF_CE7pw",
    authDomain: "review.demuxed.com",
    databaseURL: "https://demuxed-5ca37.firebaseio.com",
    projectId: "demuxed-5ca37",
    storageBucket: "demuxed-5ca37.appspot.com",
    messagingSenderId: "600508793027"
  }
};

export default PROJECTS[process.env.REACT_APP_PROJECT || STAGING];



// WEBPACK FOOTER //
// ./src/config.js